import React, { useEffect } from "react";
import { FiCheck } from "react-icons/fi";
import { clearApplyFlowOnSuccess } from "../../utils/applyFlowStorage";

const ThankYou1 = () => {
  useEffect(() => {
    // Wipe remaining apply PII from browser after successful journey
    clearApplyFlowOnSuccess();
  }, []);

  return (
    <div className="apply-now1-thankyou apply-now1-thankyou--simple">
      <div
        className="apply-now1-thankyou__check apply-now1-thankyou__check--solo"
        aria-hidden="true"
        title="Success"
      >
        <FiCheck strokeWidth={3} />
      </div>

      <h1>Thank You!</h1>
      <p className="apply-now1-thankyou__lead">
        Your loan application has been submitted successfully. Our team will get
        back to you shortly.
      </p>
    </div>
  );
};

export default ThankYou1;
